module.exports = __webpack_public_path__ + "static/media/notification_nav.be116b8c.svg";